import { useContext } from "react";

import { AuthContext, type AuthContextValue } from "@/auth/authContext";

// Access the studio auth session (§9.1.2). Throws if used outside <AuthProvider> so a
// missing provider is a loud bug, not a silent signed-out state.
export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within <AuthProvider>");
  return ctx;
}
